var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"multi-lang"},[_c('u',{staticClass:"linguval"},[_vm._v(_vm._s(_vm.$t("TERMS OF USE")))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataset)}})])}
var staticRenderFns = []

export { render, staticRenderFns }